import { useAtomValue } from 'jotai'
import { useResetAtom } from 'jotai/utils'
import React from 'react'
import { useTranslation } from 'react-i18next'

import {
  ExecuteCancelDialog,
  type ExecuteCancelDialogProps,
} from '~/components/elements/ExecuteCancelDialog'
import { useLogEvent } from '~/hooks/useLogEvent'

import { dialogInfoAtom } from '../atoms'
import { useCloseDialogWithRefresh } from '../hooks/useCloseDialogWithRefresh'
import { useDeleteCustomerAttributeMutation } from '../hooks/useDeleteCustomerAttributeMutation'

export const DeleteCustomerAttributeDialog = () => {
  const { t } = useTranslation()
  const dialogInfo = useAtomValue(dialogInfoAtom)
  if (dialogInfo?.dialogType !== 'delete') {
    throw new Error()
  }
  const { customerAttribute } = dialogInfo

  const resetDialogInfo = useResetAtom(dialogInfoAtom)

  const closeDialogWithRefresh = useCloseDialogWithRefresh()
  const logEvent = useLogEvent()
  const deleteCustomerAttributeMutation = useDeleteCustomerAttributeMutation({
    onSuccess: (data) => {
      // 他の顧客属性から参照されている場合などdeleteCustomerAttributeはresult: falseを返す。削除できていないので記録しない。
      if (data.deleteCustomerAttribute?.result) {
        logEvent('Delete customer attribute')
      }
      closeDialogWithRefresh()
    },
  })
  const handleExecute = React.useCallback<
    EH<ExecuteCancelDialogProps, 'onExecute'>
  >(() => {
    deleteCustomerAttributeMutation.mutate(customerAttribute.id)
  }, [customerAttribute.id, deleteCustomerAttributeMutation])

  return (
    <ExecuteCancelDialog
      executing={deleteCustomerAttributeMutation.isPending}
      mode="delete"
      title={t('delete_customized_segments')}
      onCancel={resetDialogInfo}
      onExecute={handleExecute}
    >
      {t('delete_confirmation', { target: customerAttribute.name })}
    </ExecuteCancelDialog>
  )
}
